__turbopack_context__.v({
  "carousel": "ToolPlatform-module-scss-module__6nhveG__carousel",
  "carouselWrapper": "ToolPlatform-module-scss-module__6nhveG__carouselWrapper",
  "headingBlock": "ToolPlatform-module-scss-module__6nhveG__headingBlock",
  "item": "ToolPlatform-module-scss-module__6nhveG__item",
  "owlitem": "ToolPlatform-module-scss-module__6nhveG__owlitem",
  "toolSection": "ToolPlatform-module-scss-module__6nhveG__toolSection",
  "toolitem": "ToolPlatform-module-scss-module__6nhveG__toolitem",
});
